import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
const Container = () => import("@/common/Container.vue");
const HomePage = () => import("@/views/home/HomePage.vue");
const PaidInfo = () => import("@/views/paidInfo/index.vue");
const AboutTy = () => import("@/views/about/index.vue");
const Weapp = () => import("@/views/weapp/index.vue");

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/weapp",
    name: "Weapp",
    component: Weapp,
  },
  {
    path: "/",
    name: "Home",
    component: Container,
    redirect: "/HomePage",
    children: [
      {
        path: "/HomePage",
        name: "HomePage",
        component: HomePage
      }, {
        path: "/AboutTy",
        name: "AboutTy",
        component: AboutTy
      },
      {
        path: "/PaidInfo",
        name: "PaidInfo",
        component: PaidInfo
      }
      
    ]
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
